<script setup lang="ts">
import {computed, onBeforeUpdate, onMounted, PropType, ref} from "vue";
import {IonIcon} from "@ionic/vue";
import {needsAction, ObjectiveGroup, useAInesObjectiveStore} from "@/helper/chat/ainesObjectives";
import {AInesObjective, AInesObjectiveState, AInesObjectiveSubject} from "@/graphql/generated/graphql";
import RichResponseListItem from "./RichResponses/components/RichResponseListItem.vue";
import date from "@/helper/datetime/date";
import Skeleton from "@/components/Skeleton.vue";
import {iconType2Icon} from "@/helper/icon";
import {getVerticalDifferencInPx, isElementBottomOutOfBoundsInScrollContainer} from '@/helper/dom'
import Transitionator from "../components/transitions/Transitionator.vue";
import CalendarDetail from "@/views/CalendarDetail/CalendarDetail.vue";
import {kapitelDateString} from "@/graphql/kapitelTypes";
import {consoleErrorApp} from "@/helper/console";

const props = defineProps({
    objective: {
        type: Object as PropType<AInesObjective>,
        required: true,
    }
})

const emit = defineEmits(["objective:click"]);

const store = useAInesObjectiveStore();

const showProgress = (objective: AInesObjective) => {
    const progress = store.planningObjectivesProgress?.get(objective.reference)
    let completed = false;
    if (progress && progress==1.0) {
        completed = true;
    }
    return objective.subject === AInesObjectiveSubject.Planning &&
        objective.state === AInesObjectiveState.InProgress &&
        !completed;
}

</script>

<template>
    <RichResponseListItem
        :key="objective.reference"
        :title="objective.title"
        :text="objective.text"
        :icon-type="showProgress(objective) ? 'progress' : iconType2Icon(objective.icon).iconType"
        :icon="showProgress(objective)? store.planningObjectivesProgress?.get(objective.reference) : iconType2Icon(objective.icon).iconId"
        :icon-color="objective.needsAction ? (objective.state == AInesObjectiveState.CompletedSuccessfully ? 'success': 'primary') : undefined"
        @click="emit('objective:click', objective)"
        :type="objective.needsAction ? (objective.state == AInesObjectiveState.CompletedSuccessfully ? 'success': 'primary') : undefined"
        :badge="objective.needsAction"
        badgeValue="!"
    >
        <!--<template v-slot:end>
            <ProgressCircle v-if="objective.subject===AInesObjectiveSubject.Planning & objective.state == AInesObjectiveState.InProgress"
                class="listItemSuffixImage"
                :stroke-width="15"
                track-color="grey-tint-1"
                :stroke-color="objective.needsAction ? 'primary-tint' : 'grey-tint-1'"
                :glow="false"
                :value=""
            />
        </template>-->
    </RichResponseListItem>
</template>

<style scoped lang="scss">

</style>
